import { PayloadAction } from "@reduxjs/toolkit";
import { GroupsState } from "../../models/GroupsState";
import { DeleteGroupPayload } from "../../payload/DeleteGroup/DeleteGroupPayload";

const deleteGroupFetch = (state: GroupsState, action: PayloadAction<DeleteGroupPayload>) => {
    state.isLoading = true;
}

export default deleteGroupFetch;